/**
 * @file Helper for surface settings
 */
import { GroupByTypes } from '@padlet/arvo'
import { processedUrl } from '@padlet/vivaldi-client'
import { isAppUsing } from 'bits/flip'
import { __ } from 'bits/intl'

const DEFAULT_MAX_GRADE = 100

const GROUP_BY_DATA = {
  [GroupByTypes.None]: {
    icon: 'close',
    name: __('No groups'),
    description: '',
  },
  [GroupByTypes.Section]: {
    icon: 'section',
    name: __('Sections'),
    description: __('Group posts by their assigned section'),
  },
}

enum ReactionTypes {
  None = 'none',
  Like = 'like',
  Vote = 'vote',
  Star = 'star',
  Grade = 'grade',
}

const REACTIONS_DATA = {
  [ReactionTypes.None]: {
    icon: isAppUsing('surfaceSettingsV2') ? 'border' : 'placeholder',
    name: __('None'),
    description: __('No reactions'),
    previewIcon: 'border',
  },
  [ReactionTypes.Like]: {
    icon: isAppUsing('surfaceSettingsV2') ? 'heart_outline_thin' : 'favorite',
    name: __('Like'),
    description: __('Like posts'),
    previewIcon: 'heart_filled',
  },
  [ReactionTypes.Vote]: {
    icon: isAppUsing('surfaceSettingsV2') ? 'thumb_up_outline' : 'thumbs_up_down',
    name: __('Vote'),
    description: __('Upvote or downvote posts'),
    previewIcon: 'thumb_up_filled',
  },
  [ReactionTypes.Star]: {
    icon: isAppUsing('surfaceSettingsV2') ? 'star_outline' : 'star',
    name: __('Star'),
    description: __('Give posts 1-5 stars'),
    previewIcon: 'star_filled',
  },
  [ReactionTypes.Grade]: {
    icon: isAppUsing('surfaceSettingsV2') ? 'checkbox_person_outline' : 'tick',
    name: __('Grade'),
    description: __('Give numeric scores to posts'),
    previewIcon: 'checkbox_person_filled',
  },
}

function processedEmojiUrl(url: string): string {
  return processedUrl(url, { width: 64, height: 64, preset: 'icon' })
}

export { GROUP_BY_DATA, ReactionTypes, REACTIONS_DATA, DEFAULT_MAX_GRADE, processedEmojiUrl }
